import { App } from './containers';
export default App;
